import { Box, Image, Stack, Text } from "grommet";
import React from "react";
import { Link } from "react-router-dom";
import { AliasViewModel } from "./AliasStore";
import Avatar from "react-avatar";

export const AliasTile = ({ alias, size = "medium", profileOnly = false, imageSizeOverride, fontSizeOverride, hideName = false }: { alias: AliasViewModel; size?: string; profileOnly?: boolean; imageSizeOverride?: string; fontSizeOverride?: string; hideName?: boolean }) => {
    const [ts, setTs] = React.useState(+Date.now());

    const content = () => (
        <>
            {size == "small" && (
                <Box align="center" justify="center">
                    {alias.profileUri && (
                        <Stack anchor="bottom-right">
                            <Image src={alias.profileUri + "?ts=" + ts} width={imageSizeOverride || "50px"}></Image>
                            {!profileOnly && <Avatar src={alias.photoUri + "?ts=" + ts} name={alias.name} size="20px" alt="" />}
                        </Stack>
                    )}
                    {!alias.profileUri && !profileOnly && <Avatar src={alias.photoUri + "?ts=" + ts} name={alias.name} size="30px" alt="" />}
                    {!alias.profileUri && profileOnly && <Image src={"/images/faces/blank.png"} width={imageSizeOverride || "50px"}></Image>}
                </Box>
            )}
            {size == "medium" && (
                <Box key={alias.id} background={"background-back"} pad="small" gap="xsmall" height="auto" justify="between" fill="vertical" hoverIndicator="background-front" onClick={() => {}}>
                    <Box align="center" justify="center">
                        {alias.profileUri && (
                            <Stack anchor="bottom-right">
                                <Image src={alias.profileUri + "?ts=" + ts} width={imageSizeOverride || "70px"}></Image>
                                {!profileOnly && <Avatar src={alias.photoUri + "?ts=" + ts} name={alias.name} size="25px" alt="" />}
                            </Stack>
                        )}
                        {!alias.profileUri && !profileOnly && <Avatar src={alias.photoUri + "?ts=" + ts} name={alias.name} size="40px" alt="" />}
                        {!alias.profileUri && profileOnly && <Image src={"/images/faces/blank.png"} width={imageSizeOverride || "70px"}></Image>}
                    </Box>
                    {!hideName && (
                        <Box>
                            <Box align="center" justify="center">
                                <Text size={fontSizeOverride || "medium"}>{AliasViewModel.displayName(alias)}</Text>
                            </Box>
                        </Box>
                    )}
                </Box>
            )}
            {size == "large" && (
                <Box align="center" justify="center">
                    {alias.profileUri && (
                        <Stack anchor="bottom-right">
                            <Image src={alias.profileUri + "?ts=" + ts} width={imageSizeOverride || "300px"}></Image>
                            {!profileOnly && <Avatar src={alias.photoUri + "?ts=" + ts} name={alias.name} size="20px" alt="" />}
                        </Stack>
                    )}
                    {!alias.profileUri && !profileOnly && <Avatar src={alias.photoUri + "?ts=" + ts} name={alias.name} size="30px" alt="" />}
                    {!alias.profileUri && profileOnly && <Image src={"/images/faces/blank.png"} width={imageSizeOverride || "300px"}></Image>}
                    {!hideName && (
                        <Box align="center" justify="center">
                            <Text size={fontSizeOverride || "medium"}>{AliasViewModel.displayName(alias)}</Text>
                        </Box>
                    )}
                </Box>
            )}
        </>
    );

    return profileOnly ? (
        content()
    ) : (
        <Link to={`/aliases/${alias.id}`} style={{ textDecoration: "none" }}>
            {content()}
        </Link>
    );
};
